// A simple prototype view for the JSON editor.

import { useEffect, useState } from 'react';

import { Button, TextField, Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { generatePolicyXML } from '../../jsonParsing/policyXMLGeneration';
import { getSessionId } from '../../store';
import { getTenantSettings } from '../../jsonParsing/utils';

export const JsonEditorPrototype = () => {
  const [jsonInput, setJsonInput] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [policyId, setPolicyId] = useState('');
  const [xmlOutput, setXMLOutput] = useState('');
  const [rpOutput, setRPOutput] = useState('');
  const sessionID = useSelector(getSessionId);

  const processConditionalsJson = (jsonInput: string, tenantIdInput: string, policyIdInput: string) => {
    let jsonEditorState = JSON.parse(jsonInput);
    let xOutputRaw = generatePolicyXML(jsonEditorState, sessionID, { enableJavascript: false });
    if (xOutputRaw) {
      setXMLOutput(xOutputRaw.policyXML);
      setRPOutput(xOutputRaw.relyingParties.join('\r\n'));
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <TextField
        id="tenantId"
        label="Tenant ID"
        onChange={(e) => {
          setTenantId(e.currentTarget.value);
        }}
        value={tenantId}
      />
      <TextField
        id="policyId"
        label="Policy ID"
        onChange={(e) => {
          setPolicyId(e.currentTarget.value);
        }}
        value={policyId}
      />
      <TextField
        id="jsonInput"
        label="Insert JSON"
        onChange={(e) => {
          setJsonInput(e.currentTarget.value);
        }}
        value={jsonInput}
        rows={5}
        multiline
      />
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'space-between' }}>
        <Button
          variant="contained"
          onClick={(e) => {
            processConditionalsJson(jsonInput, tenantId, policyId);
          }}
        >
          Convert Tree
        </Button>
      </Box>

      <TextField label="XML Output" value={xmlOutput} rows={5} multiline />
      <TextField label="RP Files" value={rpOutput} rows={5} multiline />
    </Box>
  );
};
